import { Component, OnInit } from '@angular/core';
import {
  AbstractControl,
  FormControl,
  FormGroup,
  ValidatorFn,
} from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { HeaderService } from '@app/service/header/header.service';
import { StateService } from 'src/app/service/state/state.service';
import { UserService } from 'src/app/service/user-service/user.service';
import { RouteComponent } from '../../route.component';
import { SelectorItem } from '@app/component/selector/selector.component';
import { ValuePipe } from '@app/shared/pipe/value.pipe';
import { LoanOption } from '@app/route/shared/LoanOption';

@Component({
  selector: 'app-de-select-iban',
  templateUrl: './de-select-iban.component.html',
  styleUrls: ['../../page-shared.css', './de-select-iban.component.scss'],
})
export class DeSelectIbanComponent extends RouteComponent implements OnInit {
  constructor(
    protected router: Router,
    protected route: ActivatedRoute,
    protected stateService: StateService,
    protected headerService: HeaderService,
    private userService: UserService,
    private valuePipe: ValuePipe
  ) {
    super(router, route, stateService, headerService);
  }
  navigationInProgress = false;
  selectoritems: SelectorItem[] = [];
  ibans: any[] = [];
  selectedIban = null;
  modalActive = false;
  color = '#DB305E';
  invalidPRStateForProceeding = false;
  selectedLoanOption: any;
  directDebitConsentData =
    "Wenn Sie auf 'Bestätigen' klicken, ermächtigen Sie Frink AB (Zaver), Anweisungen an Ihre Bank zu senden, um Ihr Konto gemäß dem Sepa-Lastschriftmandat zu belasten. Bedingungen ansehen";
  loading = true;
  showError = false;
  form: FormGroup;
  ibanFetchLoading = false;
  subHeadingText: string = 'Zahlungskonto auswählen';

  ngOnInit() {
    this.loading = false;

    this.form = new FormGroup({
      iban: new FormControl(this.selectedIban, [this.ibanValidator()]),
    });

    this.ibanFetchLoading = true;
    this.userService.fetchIbans().then((data: any) => {
      this.ibans = data;
      this.ibanFetchLoading = false;

      if (this.ibans.length === 1) {
        this.selectedIban = this.ibans[0];
        this.subHeadingText = 'Zahlungskonto';
        this.form.markAsPristine();
      }
    });

    if (this.state.loanOptions) {
      this.selectedLoanOption = this.state.loanOptions.find(
        (loanOption: LoanOption) =>
          loanOption.termId === this.state.loanOfferId.replace(/\"/g, '')
      );
    }
  }

  ibanValidator(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
      const iban = this.selectedIban;
      return iban ? null : { inValid: { value: control.value } };
    };
  }

  ibanFormatter(iban: string) {
    return iban
      .split(' ')
      .join('')
      .replace(/(.{4})/g, '$1 ');
  }

  selectIban(iban: any): void {
    this.selectedIban = iban;
    this.form.setValue({ iban: iban });
  }

  validateIbanSelected(): boolean {
    if (this.ibans.length <= 0) {
      return false;
    }

    if (this.ibans.length == 1 && this.form.valid) {
      return true;
    }

    if (this.ibans.length > 1 && this.selectedIban != null && this.form.valid) {
      return true;
    }
  }

  async handleCtaClick() {
    this.navigationInProgress = true;
    if (this.form.valid) {
      try {
        const formattedIbanNumber = this.selectedIban.trim().replace(/\s/g, '');
        await this.userService.registerIban(
          formattedIbanNumber,
          this.directDebitConsentData
        );
        await this.navigate();
      } catch (err) {
        this.handleError(err);
      }
    } else {
      this.showError = true;
    }
    this.navigationInProgress = false;
  }

  deactivateModal(): void {
    this.modalActive = false;
  }

  openURLinNewWindow(url: string): void {
    window.open(url, '_blank');
  }

  openModalWithTerms(): void {
    this.getModalPurchaseInfo();
  }

  getModalPurchaseInfo(): void {
    this.selectoritems = [
      {
        tab: 'Ihr Kauf',
        title: 'Zusammenfassung',
        lineItems: this.state.paymentInformation?.lineItems,
        totalValue: this.stateService.getCustomTaxTypeText(
          `Gesamtbetrag inkl. MwSt: ${this.valuePipe.transform(
            this.state.totalCheckoutValue
          )}`,
          this.state.checkoutCustomizations
        ),
      },
      {
        tab: 'SEPA',
        title: 'SEPA-Lastschrift-Mandat',
        descriptions: [
          {
            text: 'Ich ermächtige (a) Frink AB (Zaver), Gläubiger-Identifikationsnummer DE34ZZZ00002650270,  Zahlungen von meinem Konto mittels Lastschrift einzuziehen. Zugleich (b) weise ich mein Kreditinstitut an, die von Zaver auf mein Konto gezogenen Lastschriften einzulösen. Ich kann innerhalb von acht Wochen, beginnend mit dem Belastungsdatum, die Erstattung des belasteten Betrages verlangen. Es gelten dabei die mit meinem Kreditinstitut vereinbarten Bedingungen.',
          },
        ],
      },
    ];
    this.modalActive = true;
  }
}
